"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _LoginInformation = _interopRequireDefault(require("../components/LoginInformation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Profile = _ref => {
  let {
    profileInformation
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "profile"
  }, /*#__PURE__*/_react.default.createElement(_core.PageHeader, {
    title: "My Profile"
  }), profileInformation, /*#__PURE__*/_react.default.createElement(_LoginInformation.default, null));
};
Profile.propTypes = {
  profileInformation: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object])
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Profile);
//# sourceMappingURL=Profile.js.map